module.exports = __webpack_public_path__ + "img/swarm.5ea9a152.png";